<div class="logout" role="menu" aria-label="Logout menu">
  <div class="logout-top">
    <div class="logout-icon">
      <mat-icon svgIcon="user"></mat-icon>
    </div>

    <div class="logout-text">
      <div class="logout-label">Signed in as</div>
      <div class="logout-email">{{ email }}</div>
    </div>
  </div>

  <div class="logout-divider"></div>

  <div class="logout-actions">
    <button type="button" class="logout-signout" (click)="onSignOut()">Sign out</button>
  </div>
</div>
